export const motivationsListES = [
  {
    id: "1",
    title: "Balance Profesional",
    desc: "Estar contentos con el recorrido profesional desempeñado, por los puestos ocupados en el pasado y por los objetivos laborales logrados. Sentir satisfacción por el hecho de haber logrado visibilidad y oportunidades de crecimiento y aprendizaje significativas.",
    value: "",
    name: "professional_balance",
  },
  {
    id: "2",
    title: "Satisfacción por el Puesto",
    desc: "Sentirse realizado/a por el puesto actual, sentirse satisfecho/a en el desempeño de las tareas propias y en el cumplimiento de las responsabilidades asociadas a la posición profesional.",
    value: "",
    name: "job_satisfaction",
  },
  {
    id: "3",
    title: "Compromiso",
    desc: "Estar involucrado/a emocionalmente y sentirse parte de la organización en la que se trabaja. Sentirse parte activa e integrante de la empresa y los procesos, compartiendo sus valores y sintiendo el deseo de aportar valor añadido personal.",
    value: "",
    name: "commitment",
  },
  {
    id: "4",
    title: "Carrera",
    desc: "Obtener motivación por la oportunidad de seguir un recorrido profesional mediante el cual se puedan alcanzar posiciones y roles progresivamente más relevantes. Sentirse más estimulado/a que otras personas por la posibilidad de progresar significativamente.",
    value: "",
    name: "career",
  },
  {
    id: "5",
    title: "Desarrollo de Competencias",
    desc: "Tener interés en buscar un trabajo que ofrezca oportunidades de aprendizaje y de adquisición de nuevos conocimientos. Estar especialmente motivado/a por la posibilidad de desarrollar las competencias profesionales propias.",
    value: "",
    name: "skills_development",
  },
  {
    id: "6",
    title: "Proyecto Profesional",
    desc: "Manifestar el empuje necesario para perseguir un proyecto profesional bien definido, claro y consciente, orientando y optimizando las propias energías hacia su consecución.",
    value: "",
    name: "professional_proyect",
  },
  {
    id: "7",
    title: "Orientación a las Relaciones Interpersonales",
    desc: "Sentirse estimulado/a por la posibilidad, en el trabajo, de relacionarse e interactuar con los demás. Buscar puestos que permitan el contacto constante con otras personas y con distintos estilos profesionales.",
    value: "",
    name: "orientation_interpersonal_relations",
  },
  {
    id: "8",
    title: "Orientación Conceptual",
    desc: "Estar motivados por la posibilidad de realizar tareas conceptuales. Disfrutar del razonamiento abstracto y teórico. Disfrutar menos las actividades manuales.",
    value: "",
    name: "conceptual_orientation",
  },
  {
    id: "9",
    title: "Orientación de la Gestión",
    desc: "Sentirse motivado por la realización de trabajos que den la posibilidad de asumir la guía de un grupo. Buscar puestos que permitan asumir posiciones de coordinación, en los que sea necesario dirigir, supervisar e influenciar a los demás.",
    value: "",
    name: "management_orientation",
  },
  {
    id: "10",
    title: "Orientación Comercial",
    desc: "Sentir gratificación por la posibilidad de ejercer competencias comerciales y en el ámbito de la negociación. Sentirse atraído/a por los negocios y las situaciones que tengan como enfoque principal la venta y/o negociación.",
    value: "",
    name: "business_orientation",
  },
  {
    id: "11",
    title: "Orientación al Objetivo",
    desc: "Buscar la ocasión para ponerse a prueba y para medirse en situaciones importantes. Sentirse atraído por la posibilidad de invertir energías personales para alcanzar objetivos que supongan un reto, pese a las dificultades.",
    value: "",
    name: "target_orientation",
  },
  {
    id: "12",
    title: "Orientación a la Tipología del Trabajo",
    desc: "Obtener satisfacción profesional y el empuje motivacional propio de contenidos específicos del puesto y de la posición. Sentir pasión por temáticas específicas, por las particularidades y variables que caracterizan al trabajo de uno mismo.",
    value: "",
    name: "orientation_type_work_performed",
  },
  {
    id: "13",
    title: "Orientación a la Innovación",
    desc: "Sentirse motivado por la oportunidad de trabajar con un enfoque creativo, por la posibilidad de descubrir e implementar soluciones innovadoras y originales. Sentirse estimulado por entornos y roles menos tradicionales.",
    value: "",
    name: "innovation_orientation",
  },
  {
    id: "14",
    title: "Aspecto Económico",
    desc: "Sentir la tensión de buscar siempre un compenso económico mejor. Orientarse hacia situaciones que sean más ventajosas en términos de compensación, retribución variable y beneficios.",
    value: "",
    name: "economic_aspect",
  },
  {
    id: "15",
    title: "Autonomía y Versatilidad",
    desc: "Sentirse estimulado por la posibilidad de trabajar en entorno organizativos dinámicos y menos estructurados, en los que se disfrute de un mayor grado de autonomía. Buscar la variedad en el desempeño de la actividad profesional propia.",
    value: "",
    name: "autonomy_versatility",
  },
  {
    id: "16",
    title: "Seguridad",
    desc: "Sentirse atraído/a por las situaciones que transmiten seguridad y estabilidad. Preferir la posibilidad de trabajar en organizaciones sólidas, preferentemente de gran tamaño.",
    value: "",
    name: "safety",
  },
  {
    id: "17",
    title: "Prestigio",
    desc: "Buscar puestos que garanticen reconocimiento y estatus. Sentir gratificación por la posibilidad de ocupar puestos considerados de prestigio y relacionados con el poder.",
    value: "",
    name: "prestige",
  },
];

export const motivationsListPT = [
  {
    id: "1",
    title: "Equilíbrio Profissional",
    desc: "Estar contente com a trajetória profissional percorrida, pelos cargos ocupados no passado e pelos objetivos profissionais alcançados. Sentir satisfação por ter alcançado visibilidade e oportunidades significativas de crescimento e aprendizado.",
    value: "",
    name: "professional_balance",
  },
  {
    id: "2",
    title: "Satisfação com o Cargo",
    desc: "Sentir-se realizado/a com o cargo atual, satisfeito/a com o desempenho das tarefas próprias e o cumprimento das responsabilidades associadas à posição profissional.",
    value: "",
    name: "job_satisfaction",
  },
  {
    id: "3",
    title: "Comprometimento",
    desc: "Estar emocionalmente envolvido/a e sentir-se parte da organização em que trabalha. Sentir-se parte ativa e integrante da empresa e dos processos, compartilhando seus valores e desejando agregar valor pessoalmente.",
    value: "",
    name: "commitment",
  },
  {
    id: "4",
    title: "Carreira",
    desc: "Obter motivação pela oportunidade de seguir uma carreira profissional em que seja possível alcançar posições e funções progressivamente mais relevantes. Sentir-se mais estimulado/a do que outras pessoas pela possibilidade de progredir significativamente.",
    value: "",
    name: "career",
  },
  {
    id: "5",
    title: "Desenvolvimento de Competências",
    desc: "Ter interesse em buscar um trabalho que ofereça oportunidades de aprendizado e aquisição de novos conhecimentos. Estar especialmente motivado/a pela possibilidade de desenvolver suas competências profissionais.",
    value: "",
    name: "skills_development",
  },
  {
    id: "6",
    title: "Projeto Profissional",
    desc: "Demonstrar o impulso necessário para perseguir um projeto profissional bem definido, claro e consciente, direcionando e otimizando suas próprias energias para alcançá-lo.",
    value: "",
    name: "professional_proyect",
  },
  {
    id: "7",
    title: "Orientação para Relações Interpessoais",
    desc: "Sentir-se estimulado/a pela possibilidade, no trabalho, de se relacionar e interagir com os outros. Procurar cargos que permitam o contato constante com outras pessoas e com diferentes estilos profissionais.",
    value: "",
    name: "orientation_interpersonal_relations",
  },
  {
    id: "8",
    title: "Orientação Conceitual",
    desc: "Ser motivado/a pela possibilidade de realizar tarefas conceituais. Gostar do raciocínio abstrato e teórico. Desfrutar menos das atividades manuais.",
    value: "",
    name: "conceptual_orientation",
  },
  {
    id: "9",
    title: "Orientação para Gestão",
    desc: "Sentir-se motivado/a pela realização de trabalhos que permitam assumir a liderança de um grupo. Procurar cargos que possibilitem assumir posições de coordenação, em que seja necessário dirigir, supervisionar e influenciar os outros.",
    value: "",
    name: "management_orientation",
  },
  {
    id: "10",
    title: "Orientação Comercial",
    desc: "Sentir satisfação pela possibilidade de exercer competências comerciais e no âmbito da negociação. Sentir-se atraído/a pelos negócios e situações que tenham como foco principal a venda e/ou negociação.",
    value: "",
    name: "business_orientation",
  },
  {
    id: "11",
    title: "Orientação para Objetivos",
    desc: "Buscar a oportunidade de se testar e medir-se em situações importantes. Sentir-se atraído/a pela possibilidade de investir energias pessoais para alcançar objetivos desafiadores, apesar das dificuldades.",
    value: "",
    name: "target_orientation",
  },
  {
    id: "12",
    title: "Orientação para a Tipo do Trabalho",
    desc: "Obter satisfação profissional e o impulso motivacional próprio de conteúdos específicos do cargo e da posição. Sentir paixão por temas específicos, pelas particularidades e variáveis que caracterizam o próprio trabalho.",
    value: "",
    name: "orientation_type_work_performed",
  },
  {
    id: "13",
    title: "Orientação para Inovação",
    desc: "Sentir-se motivado/a pela oportunidade de trabalhar com um enfoque criativo, pela possibilidade de descobrir e implementar soluções inovadoras e originais. Sentir-se estimulado por ambientes e funções menos tradicionais.",
    value: "",
    name: "innovation_orientation",
  },
  {
    id: "14",
    title: "Aspecto Econômico",
    desc: "Sentir a tensão de buscar sempre uma compensação econômica melhor. Orientar-se para situações que sejam mais vantajosas em termos de remuneração, remuneração variável e benefícios.",
    value: "",
    name: "economic_aspect",
  },
  {
    id: "15",
    title: "Autonomia e Versatilidade",
    desc: "Sentir-se estimulado/a pela possibilidade de trabalhar em ambientes organizacionais dinâmicos e menos estruturados, nos quais se desfrute de um maior grau de autonomia. Procurar variedade no desempenho da atividade profissional.",
    value: "",
    name: "autonomy_versatility",
  },
  {
    id: "16",
    title: "Segurança",
    desc: "Sentir-se atraído/a por situações que transmitam segurança e estabilidade. Preferir a possibilidade de trabalhar em organizações sólidas, preferencialmente de grande porte.",
    value: "",
    name: "safety",
  },
  {
    id: "17",
    title: "Prestígio",
    desc: "Buscar cargos que garantam reconhecimento e status. Sentir satisfação pela possibilidade de ocupar cargos considerados de prestígio e relacionados ao poder.",
    value: "",
    name: "prestige",
  },
];
